// Uniquely Made LLC — Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ── Mobile Menu Toggle ──
  var hamburger = document.getElementById('hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
    });
    document.addEventListener('click', function (e) {
      if (!hamburger.contains(e.target) && !mobileNav.contains(e.target)) {
        mobileNav.classList.remove('open');
      }
    });
  }

  // ── Product Page: Variant Pills ──
  var variantPills = document.querySelectorAll('.variant-pill');
  variantPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var group = pill.closest('.variant-pills');
      if (group) {
        group.querySelectorAll('.variant-pill').forEach(function (p) {
          p.classList.remove('active');
          p.setAttribute('aria-checked', 'false');
        });
      }
      pill.classList.add('active');
      pill.setAttribute('aria-checked', 'true');
      // Update hidden variant select if present
      var variantId = pill.dataset.variantId;
      var variantSelect = document.getElementById('variant-select');
      if (variantSelect && variantId) {
        variantSelect.value = variantId;
      }
      // Update price display
var price = pill.dataset.price;
var priceEl = document.getElementById('product-price');
if (priceEl && price) {
  priceEl.textContent = price;
}
var image = pill.dataset.image;
var mainImg = document.getElementById('main-product-img');
if (mainImg && image) {
  mainImg.src = image;
}   
 });
  });

  // ── Product Image Thumbnails ──
var thumbs = document.querySelectorAll('.product-page__thumb');
var mainImg = document.getElementById('main-product-img');

thumbs.forEach(function (thumb) {
  thumb.addEventListener('click', function () {
    thumbs.forEach(function (t) { t.classList.remove('active'); });
    thumb.classList.add('active');
    if (mainImg) mainImg.src = thumb.dataset.full;
  });
});
  // ── Quantity Stepper ──
  var qtyInput = document.querySelector('.qty-input');
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus = document.querySelector('.qty-plus');
  if (qtyInput) {
    if (qtyMinus) qtyMinus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      if (val > 1) qtyInput.value = val - 1;
    });
    if (qtyPlus) qtyPlus.addEventListener('click', function () {
      var val = parseInt(qtyInput.value) || 1;
      qtyInput.value = val + 1;
    });
  }

});
